export default __webpack_public_path__ + "static/media/error.57267400.mp3";